module.exports = __webpack_public_path__ + "img/c01e7d3488218a2e0941e061034e88f6.png";